import { getAppConfig } from '../config/appConfig'

export const getImpersonationUserUrl = url => {
  const config = getAppConfig()
  if (config.isImpersonation) {
    return url + '?bpId=' + config.bpId
  }
  return url
}
